import { create } from "zustand";
import useModalManager, { MODAL_IDS } from "./useModalManager";

interface PopupState {
  openReleasingPopup: boolean;
  setOpenReleasingPopup: (value: boolean) => void;
}

export const useFeaturesPopupStore = create<PopupState>((set) => ({
  openReleasingPopup: localStorage.getItem("showReleasingPopup") !== "false",
  
  setOpenReleasingPopup: (value: boolean) => {
    if (value) {
      // Register with modal manager to ensure only one popup is active
      useModalManager.getState().openModal(MODAL_IDS.RELEASING_NOTES, () => {
        // This callback is called when another modal wants to open
        // We close this popup to make room for the new modal
        set({ openReleasingPopup: false });
      });
    } else {
      // Notify modal manager that this modal is closing
      useModalManager.getState().closeModal(MODAL_IDS.RELEASING_NOTES);
    }
    
    set({ openReleasingPopup: value });
  },
}));
